<script setup>
import '@/styles/css/become-sub-broker.scss'
import '@/styles/3-modules/upstox-redesign-base.scss'
import '@/styles/css/new-ap-page.scss'
import { onMounted } from 'vue';
onMounted(()=>{
  require('@/assets/js/partner.js')
})
</script>
<template>
  <main class="upstox-design-base upstox-bs-broker">
    <div class="earningWays bg-gray-300">
      <div class="container">
        <div class="row">
          <div class="headings col-md-12">
            <h2 class="center-heading">Ways to earn with us</h2>
          </div>

          <div class="col-sm-6">
            <div class="earningWays-box center-heading">
              <div class="iconBlock">
                <img
                  src="https://upstox.com/app/themes/upstox/dist/img/sub-broker-new/Brokerage-Shaeing.svg"
                  alt="Brokerage Sharing"
                  loading="lazy"
                />
              </div>
              <div class="contentBox">
                <div class="content-box-heading">Brokerage sharing</div>
                <p class="pt-1 description">
                  Get a share of the brokerage from each trade your referred
                  client makes.
                </p>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="earningWays-box center-heading">
              <div class="iconBlock">
                <img
                  src="https://upstox.com/app/themes/upstox/dist/img/sub-broker-new/Referal-Incentive.svg"
                  alt="Referal Incentive"
                  loading="lazy"
                />
              </div>
              <div class="contentBox">
                <div class="content-box-heading">Referral incentive</div>
                <p class="pt-1 description">
                  Earn incentives through referrals, the more you refer the more
                  you earn.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="whoCanPartner">
      <div class="container customContainer">
        <div class="row partners justify-content-center">
          <div class="headings mrhead col-md-12">
            <h2>People who partner with us</h2>
          </div>
          <div class="col-md-6 mb-20">
            <div class="finance-box partnerBox">
              <div class="partnerimg">
                <img
                  src="https://upstox.com/app/themes/upstox/dist/img/sub-broker-new/finance.png"
                  alt="Finance enthusiast"
                  loading="lazy"
                />
              </div>
              <h4 class="mb-2">Finance enthusiast</h4>
              <p>
                Your interest lies in finance and the stock market. You take
                great pleasure in guiding others with investment options.
              </p>
            </div>
          </div>
          <div class="col-md-6 mb-20">
            <div class="internet-box partnerBox">
              <div class="partnerimg">
                <img
                  src="https://upstox.com/app/themes/upstox/dist/img/sub-broker-new/internet.png"
                  alt="Internet Influencer"
                  loading="lazy"
                />
              </div>
              <h4 class="mb-2">Internet Influencer</h4>
              <p>
                Social media is your playground. You have a good number of
                followers who easily consume all the content you share.
              </p>
            </div>
          </div>
          <div class="col-md-6 mb-20">
            <div class="people-box partnerBox">
              <div class="partnerimg">
                <img
                  src="https://upstox.com/app/themes/upstox/dist/img/sub-broker-new/people.png"
                  alt="People Person"
                  loading="lazy"
                />
              </div>
              <h4 class="mb-2">People Person</h4>
              <p>
                People love you! And you love people! So, by default, marketing
                comes to you, naturally. You can sell, and do it rather well.
              </p>
            </div>
          </div>
          <div class="col-md-6 mb-20">
            <div class="self-box partnerBox">
              <div class="partnerimg">
                <img
                  src="https://upstox.com/app/themes/upstox/dist/img/sub-broker-new/self.png"
                  alt="Self Starter"
                  loading="lazy"
                />
              </div>
              <h4 class="mb-2">Self Starter</h4>
              <p>
                "I'm my own boss", that's your mantra. You just want to earn and
                grow. The desire is powered by your dedication. And that takes
                you places!
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <section class="soundLike text-center">
      <div class="container">
        <p>
          Sounds like you? <br />
          We’d love to have you onboard!
        </p>
        <button id="start-investing" class="btn-theme fw-700 text-white rounded-full">
          Enroll as a Partner
        </button>
      </div>
    </section>

    <div class="partner-page">
      <div class="testimonialSection">
        <div class="container customContainer">
          <div class="row">
            <div class="col-md-12">
              <div
                class="owl-carousel owl-theme testimonialArea owl-loaded owl-drag"
              >
                <div class="owl-stage-outer">
                  <div
                    class="owl-stage"
                  >
                    <div
                      class="owl-item cloned"
                      style="width: 814px; margin-right: 20px"
                    >
                      <div class="item text-center">
                        <span class="testimonial">
                          <p>
                            "Partnering with Upstox has several advantages and
                            benefits like a good second source of income.It has
                            a very transparent and user friendly dashboard where
                            we can upload leads and track status of each and
                            every leads"
                          </p>
                          <p class="userDetails">
                            Amit Gupta
                            <small>Partner Since 16/01/2019</small>
                          </p>
                        </span>
                      </div>
                    </div>
                    <div
                      class="owl-item cloned"
                      style="width: 814px; margin-right: 20px"
                    >
                      <div class="item text-center">
                        <span class="testimonial">
                          <p>
                            "I have been a partner with Upstox since 2 years.
                            Upstox, through its wide reach and customer centric
                            approach has made a significant mark in the discount
                            broking industry."
                          </p>
                          <p class="userDetails">
                            Sanoob Sidiq
                            <small>Partner Since 2016</small>
                          </p>
                        </span>
                      </div>
                    </div>
                    <div
                      class="owl-item cloned"
                      style="width: 814px; margin-right: 20px"
                    >
                      <div class="item text-center">
                        <span class="testimonial">
                          <p>
                            "The risk of operations is handled by Upstox and the
                            benefit of profit is enjoyed by the partner. Where
                            else would you get 50% for acquiring a client for
                            life? The best part is we get assistance in opening
                            accounts of clients too from the sales team once we
                            add them in CRM."
                          </p>
                          <p class="userDetails">
                            Ravi Kiran
                            <small>Partner Since 2016</small>
                          </p>
                        </span>
                      </div>
                    </div>
                    <div
                      class="owl-item active"
                      style="width: 814px; margin-right: 20px"
                    >
                      <div class="item text-center">
                        <span class="testimonial">
                          <p>
                            "My partnership with Upstox has been really
                            advantageous.Upstox has got a neat, user-friendly
                            and cutting-edge partner platform that allows you to
                            generate leads, follow up with them and drive sales.
                            Real-time earnings and seamless payouts are done in
                            a transparent fashion."
                          </p>
                          <p class="userDetails">
                            Shikha singh
                            <small>Partner Since 15/11/2018</small>
                          </p>
                        </span>
                      </div>
                    </div>
                    <div
                      class="owl-item"
                      style="width: 814px; margin-right: 20px"
                    >
                      <div class="item text-center">
                        <span class="testimonial">
                          <p>
                            "The best thing about Upstox is the account opening
                            process which is completely online with no paperwork
                            needed. Secondly, there is total transparency in the
                            dashboard platform, which enables me to check all
                            the referral details, anywhere, anytime."
                          </p>
                          <p class="userDetails">
                            Prabhu Selvaraj
                            <small>Partner Since 13/07/2018</small>
                          </p>
                        </span>
                      </div>
                    </div>
                    <div
                      class="owl-item"
                      style="width: 814px; margin-right: 20px"
                    >
                      <div class="item text-center">
                        <span class="testimonial">
                          <p>
                            "Partnering with Upstox has several advantages and
                            benefits like a good second source of income.It has
                            a very transparent and user friendly dashboard where
                            we can upload leads and track status of each and
                            every leads"
                          </p>
                          <p class="userDetails">
                            Amit Gupta
                            <small>Partner Since 16/01/2019</small>
                          </p>
                        </span>
                      </div>
                    </div>
                    <div
                      class="owl-item"
                      style="width: 814px; margin-right: 20px"
                    >
                      <div class="item text-center">
                        <span class="testimonial">
                          <p>
                            "I have been a partner with Upstox since 2 years.
                            Upstox, through its wide reach and customer centric
                            approach has made a significant mark in the discount
                            broking industry."
                          </p>
                          <p class="userDetails">
                            Sanoob Sidiq
                            <small>Partner Since 2016</small>
                          </p>
                        </span>
                      </div>
                    </div>
                    <div
                      class="owl-item"
                      style="width: 814px; margin-right: 20px"
                    >
                      <div class="item text-center">
                        <span class="testimonial">
                          <p>
                            "The risk of operations is handled by Upstox and the
                            benefit of profit is enjoyed by the partner. Where
                            else would you get 50% for acquiring a client for
                            life? The best part is we get assistance in opening
                            accounts of clients too from the sales team once we
                            add them in CRM."
                          </p>
                          <p class="userDetails">
                            Ravi Kiran
                            <small>Partner Since 2016</small>
                          </p>
                        </span>
                      </div>
                    </div>
                    <div
                      class="owl-item cloned"
                      style="width: 814px; margin-right: 20px"
                    >
                      <div class="item text-center">
                        <span class="testimonial">
                          <p>
                            "My partnership with Upstox has been really
                            advantageous.Upstox has got a neat, user-friendly
                            and cutting-edge partner platform that allows you to
                            generate leads, follow up with them and drive sales.
                            Real-time earnings and seamless payouts are done in
                            a transparent fashion."
                          </p>
                          <p class="userDetails">
                            Shikha singh
                            <small>Partner Since 15/11/2018</small>
                          </p>
                        </span>
                      </div>
                    </div>
                    <div
                      class="owl-item cloned"
                      style="width: 814px; margin-right: 20px"
                    >
                      <div class="item text-center">
                        <span class="testimonial">
                          <p>
                            "The best thing about Upstox is the account opening
                            process which is completely online with no paperwork
                            needed. Secondly, there is total transparency in the
                            dashboard platform, which enables me to check all
                            the referral details, anywhere, anytime."
                          </p>
                          <p class="userDetails">
                            Prabhu Selvaraj
                            <small>Partner Since 13/07/2018</small>
                          </p>
                        </span>
                      </div>
                    </div>
                    <div
                      class="owl-item cloned"
                      style="width: 814px; margin-right: 20px"
                    >
                      <div class="item text-center">
                        <span class="testimonial">
                          <p>
                            "Partnering with Upstox has several advantages and
                            benefits like a good second source of income.It has
                            a very transparent and user friendly dashboard where
                            we can upload leads and track status of each and
                            every leads"
                          </p>
                          <p class="userDetails">
                            Amit Gupta
                            <small>Partner Since 16/01/2019</small>
                          </p>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="owl-nav">
                  <button type="button" role="presentation" class="owl-prev">
                    <i
                      class="material-icons"
                      style="color: black; font-size: 40px"
                      >keyboard_arrow_left</i
                    ></button
                  ><button type="button" role="presentation" class="owl-next">
                    <i
                      class="material-icons"
                      style="color: black; font-size: 40px"
                      >keyboard_arrow_right</i
                    >
                  </button>
                </div>
                <div class="owl-dots">
                  <button role="button" class="owl-dot active">
                    <span></span></button
                  ><button role="button" class="owl-dot"><span></span></button
                  ><button role="button" class="owl-dot"><span></span></button
                  ><button role="button" class="owl-dot"><span></span></button
                  ><button role="button" class="owl-dot"><span></span></button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="partner-page">
      <div class="allinoneDashboard">
        <div class="container customContainer">
          <div class="row">
            <div class="headingss col-md-12 text-center">
              <h2>Powerful Dashboard to help you perform your best</h2>
            </div>

            <div class="col-md-6 leftSelector">
              <div
                id="sync2"
                class="owl-carousel owl-theme owl-loaded owl-drag"
              >
                        <div class="linkerBox">
                          <span class="icon rupee"></span>
                          <div class="wrapper">
                            <div class="pie spinner-rupee"></div>
                            <div class="pie filler"></div>
                            <div class="mask"></div>
                          </div>
                          <span class="text">
                            Keep track of all your earnings
                          </span>
                        </div>
                        <div class="linkerBox">
                          <span class="icon support"></span>
                          <div class="wrapper">
                            <div class="pie spinner-rupee"></div>
                            <div class="pie filler"></div>
                            <div class="mask"></div>
                          </div>
                          <span class="text">
                            Analyse your leads and customers
                          </span>
                        </div>
                        <div class="linkerBox">
                          <span class="icon lead"></span>
                          <div class="wrapper">
                            <div class="pie spinner-rupee"></div>
                            <div class="pie filler"></div>
                            <div class="mask"></div>
                          </div>
                          <span class="text">
                            Get comprehensive support for your queries
                          </span>
                        </div>
                <div class="owl-nav disabled">
                  <button type="button" role="presentation" class="owl-prev">
                    <span aria-label="Previous">‹</span></button
                  ><button type="button" role="presentation" class="owl-next">
                    <span aria-label="Next">›</span>
                  </button>
                </div>
                <div class="owl-dots disabled"></div>
              </div>
            </div>
            <div class="col-md-6">
              <div
                id="sync1"
                class="owl-carousel owl-theme owl-loaded owl-drag"
              >
                <div class="owl-stage-outer">
                  <div
                    class="owl-stage"
                    style="
                      transform: translate3d(-882px, 0px, 0px);
                      transition: 0.25s;
                      width: 3087px;
                    "
                  >
                    <div class="owl-item cloned" style="width: 441px">
                      <div class="item">
                        <picture>
                          <source
                            srcset="
                              https://upstox.com/app/themes/upstox/dist/img/sub-broker-new/feature-2-new.webp
                            "
                            type="image/webp"
                          />
                          <img
                            src="https://upstox.com/app/themes/upstox/dist/img/sub-broker-new/feature-2-new.png"
                            alt="Analyse your leads and customers"
                            loading="lazy"
                          />
                        </picture>
                      </div>
                    </div>
                    <div class="owl-item cloned" style="width: 441px">
                      <div class="item">
                        <picture>
                          <source
                            srcset="
                              https://upstox.com/app/themes/upstox/dist/img/sub-broker-new/feature-3-new.webp
                            "
                            type="image/webp"
                          />
                          <img
                            src="https://upstox.com/app/themes/upstox/dist/img/sub-broker-new/feature-3-new.png"
                            alt="Get comprehensive support for your queries"
                            loading="lazy"
                          />
                        </picture>
                      </div>
                    </div>
                    <div class="owl-item active" style="width: 441px">
                      <div class="item">
                        <picture>
                          <source
                            srcset="
                              https://upstox.com/app/themes/upstox/dist/img/sub-broker-new/feature-1-new.webp
                            "
                            type="image/webp"
                          />
                          <img
                            src="https://upstox.com/app/themes/upstox/dist/img/sub-broker-new/feature-1-new.png"
                            alt="Keep track of all your earnings"
                            loading="lazy"
                          />
                        </picture>
                      </div>
                    </div>
                    <div class="owl-item" style="width: 441px">
                      <div class="item">
                        <picture>
                          <source
                            srcset="
                              https://upstox.com/app/themes/upstox/dist/img/sub-broker-new/feature-2-new.webp
                            "
                            type="image/webp"
                          />
                          <img
                            src="https://upstox.com/app/themes/upstox/dist/img/sub-broker-new/feature-2-new.png"
                            alt="Analyse your leads and customers"
                            loading="lazy"
                          />
                        </picture>
                      </div>
                    </div>
                    <div class="owl-item" style="width: 441px">
                      <div class="item">
                        <picture>
                          <source
                            srcset="
                              https://upstox.com/app/themes/upstox/dist/img/sub-broker-new/feature-3-new.webp
                            "
                            type="image/webp"
                          />
                          <img
                            src="https://upstox.com/app/themes/upstox/dist/img/sub-broker-new/feature-3-new.png"
                            alt="Get comprehensive support for your queries"
                            loading="lazy"
                          />
                        </picture>
                      </div>
                    </div>
                    <div class="owl-item cloned" style="width: 441px">
                      <div class="item">
                        <picture>
                          <source
                            srcset="
                              https://upstox.com/app/themes/upstox/dist/img/sub-broker-new/feature-1-new.webp
                            "
                            type="image/webp"
                          />
                          <img
                            src="https://upstox.com/app/themes/upstox/dist/img/sub-broker-new/feature-1-new.png"
                            alt="Keep track of all your earnings"
                            loading="lazy"
                          />
                        </picture>
                      </div>
                    </div>
                    <div class="owl-item cloned" style="width: 441px">
                      <div class="item">
                        <picture>
                          <source
                            srcset="
                              https://upstox.com/app/themes/upstox/dist/img/sub-broker-new/feature-2-new.webp
                            "
                            type="image/webp"
                          />
                          <img
                            src="https://upstox.com/app/themes/upstox/dist/img/sub-broker-new/feature-2-new.png"
                            alt="Analyse your leads and customers"
                            loading="lazy"
                          />
                        </picture>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="owl-nav disabled">
                  <button type="button" role="presentation" class="owl-prev">
                    <svg width="100%" height="100%" viewBox="0 0 11 20">
                      <path
                        style="fill: none; stroke-width: 1px; stroke: #000"
                        d="M9.554,1.001l-8.607,8.607l8.607,8.606"
                      ></path>
                    </svg></button
                  ><button type="button" role="presentation" class="owl-next">
                    <svg
                      width="100%"
                      height="100%"
                      viewBox="0 0 11 20"
                      version="1.1"
                    >
                      <path
                        style="fill: none; stroke-width: 1px; stroke: #000"
                        d="M1.054,18.214l8.606,-8.606l-8.606,-8.607"
                      ></path>
                    </svg>
                  </button>
                </div>
                <div class="owl-dots disabled"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="rtp">
      <div class="container">
        <div class="row">
          <div class="col-lg-6 col-md-6 col-sm-6">
            <div class="rtp-block">
              <div class="heading-rtp">Ready to Partner?</div>
              <div class="rtp-para">
                Register to jump-start your journey as an Upstox Partner.
            </div>
              <button id="rtp-signup-button" class="rtp-button">Sign up</button>
            </div>
          </div>
          <div class="text-center col-lg-6 col-md-6 col-sm-6">
            <picture>
              <source
                srcset="
                  https://upstox.com/app/themes/upstox/dist/img/sub-broker-new/stats-update.webp
                "
                type="image/webp"
              />
              <img
                class="rtp-stats img-fluid"
                src="https://upstox.com/app/themes/upstox/dist/img/sub-broker-new/stats-update.png"
                alt="Ready to Partner"
                loading="lazy"
              />
            </picture>
          </div>
        </div>
      </div>
    </div>

    <!--FAQ-->
    <section class="faq_help_section up-pricing-faqs">
      <div class="container">
        <div class="heading-section">
          <h5 class="text-center fw-700 sub-title fs-14">FAQs</h5>
          <h3 class="fs-32 bold help_here text-center">
            Frequently Asked Questions
          </h3>
        </div>
        <div class="row faq-content">
          <div
            class="panel-group"
            id="accordion"
            role="tablist"
            aria-multiselectable="true"
          >
            <div class="panel panel-default">
              <div class="panel-heading" id="headingOne">
                <h3 class="panel-title">
                  <span class="panel-trigger" val="#collapseOne">
                    <span class="expand_icon dashicons-plus"></span>
                    <span>Who is an Authorised Person?</span>
                  </span>
                </h3>
              </div>
              <div id="collapseOne" class="panel-collapse collapse">
                <div class="panel-body">
                  An Authorised Person is a person who is registered with SEBI
                  and is affiliated to a member of a recognised stock exchange.
                </div>
              </div>
            </div>

            <div class="panel panel-default">
              <div class="panel-heading" id="headingtwenty">
                <h3 class="panel-title">
                  <span class="panel-trigger" val="#collapsetwenty">
                    <span class="expand_icon dashicons-plus"></span>
                    <span>What is the main role of an Authorised Person?</span>
                  </span>
                </h3>
              </div>
              <div id="collapsetwenty" class="panel-collapse collapse">
                <div class="panel-body">
                  The main role of an Authorised Person is to recruit clients
                  under him &amp; regulate their business, based on which
                  brokerage will be generated.
                </div>
              </div>
            </div>

            <div class="panel panel-default">
              <div class="panel-heading" id="headingtwentyone">
                <h3 class="panel-title">
                  <span class="panel-trigger" val="#collapsetwentyone">
                    <span class="expand_icon dashicons-plus"></span>
                    <span
                      >What is the basic qualification to become an Authorised
                      Person</span
                    >
                  </span>
                </h3>
              </div>
              <div id="collapsetwentyone" class="panel-collapse collapse">
                <div class="panel-body">Min qualification SSC passed</div>
              </div>
            </div>

            <div class="panel panel-default">
              <div class="panel-heading" id="headingtwentytwo">
                <h3 class="panel-title">
                  <span class="panel-trigger" val="#collapsetwentytwo">
                    <span class="expand_icon dashicons-plus"></span>
                    <span>
                      Is it mandatory to have a trading and demat account for
                      becoming a partner?</span
                    >
                  </span>
                </h3>
              </div>
              <div id="collapsetwentytwo" class="panel-collapse collapse">
                <div class="panel-body">
                  To avail partner benefits, one must have an active trading and
                  a demat account.
                </div>
              </div>
            </div>

            <div class="panel panel-default">
              <div class="panel-heading" id="headingtwentythree">
                <h3 class="panel-title">
                  <span class="panel-trigger" val="#collapsetwentythree">
                    <span class="expand_icon dashicons-plus"></span>
                    <span>
                      Do we have any learning programs on the stock
                      market?</span
                    >
                  </span>
                </h3>
              </div>
              <div id="collapsetwentythree" class="panel-collapse collapse">
                <div class="panel-body">
                  We provide a link for our masterclass which will help in
                  further enhancing your knowledge.
                  <a
                    href="/investor-masterclass/#upcoming-webinars-sec"
                    >Upcoming Webinars</a
                  >
                </div>
              </div>
            </div>

            <div class="panel panel-default">
              <div class="panel-heading" id="headingtwentyfour">
                <h3 class="panel-title">
                  <span class="panel-trigger" val="#collapsetwentyfour">
                    <span class="expand_icon dashicons-plus"></span>
                    <span>
                      What will be the payout date for brokerage income?</span
                    >
                  </span>
                </h3>
              </div>
              <div id="collapsetwentyfour" class="panel-collapse collapse">
                <div class="panel-body">
                  The payout for the brokerage income is on or after 7th of
                  every month.
                </div>
              </div>
            </div>

            <div class="panel panel-default">
              <div class="panel-heading" id="headingtwentyfive">
                <h3 class="panel-title">
                  <span class="panel-trigger" val="#collapsetwentyfive">
                    <span class="expand_icon dashicons-plus"></span>
                    <span>
                      Does an Authorised Person need to register in all segments
                      and what are the charges?</span
                    >
                  </span>
                </h3>
              </div>
              <div id="collapsetwentyfive" class="panel-collapse collapse">
                <div class="panel-body">
                  To become an Authorised Person (AP) and refer customers to
                  different market segments, you need to register with a broker
                  for each specific segment. You'll only receive brokerage
                  sharing for the segments you are registered in. <br />
                  - For NSE, the registration fee is ₹5900 (including GST) for
                  both the Equity and F&amp;O markets<br />
                  - For BSE, the registration fee is ₹4720 (including GST) for
                  both the Equity and F&amp;O markets<br />
                  - For MCX, the registration fee for the Commodity Derivatives
                  segment is ₹2360 (including GST)<br />
                </div>
              </div>
            </div>

            <div class="panel panel-default">
              <div class="panel-heading" id="headingtwentysix">
                <h3 class="panel-title">
                  <span class="panel-trigger" val="#collapsetwentysix">
                    <span class="expand_icon dashicons-plus"></span>
                    <span>
                      What are the maintenance charges for Authorised Person
                      Registration?</span
                    >
                  </span>
                </h3>
              </div>
              <div id="collapsetwentysix" class="panel-collapse collapse">
                <div class="panel-body">
                  For NSE: ₹5000 plus GST<br />
                  For BSE: ₹4000 plus GST<br />
                  For MCX: ₹1000 plus GST (charged quarterly)<br />
                </div>
              </div>
            </div>

            <div class="panel panel-default">
              <div class="panel-heading" id="headingtwentysev">
                <h3 class="panel-title">
                  <span class="panel-trigger" val="#collapsetwentysev">
                    <span class="expand_icon dashicons-plus"></span>
                    <span>
                      Will one person be allowed to have multiple Authorised
                      Person registrations in different segments with different
                      broking firms?</span
                    >
                  </span>
                </h3>
              </div>
              <div id="collapsetwentysev" class="panel-collapse collapse">
                <div class="panel-body">
                  If you are currently a Authorised Person with another
                  brokerage firm in any segment, you cannot be associated with
                  any other brokerage firm as an Authorised Person.
                </div>
              </div>
            </div>

            <div class="panel panel-default">
              <div class="panel-heading" id="headingThree">
                <h3 class="panel-title">
                  <span class="panel-trigger" val="#collapseThree">
                    <span class="expand_icon dashicons-plus"></span>
                    <span>How do I refer customers to Upstox?</span>
                  </span>
                </h3>
              </div>
              <div id="collapseThree" class="panel-collapse collapse">
                <div class="panel-body">
                  Login to the Partner Dashboard, get a referral link and share
                  it with your customers!
                </div>
              </div>
            </div>
            <div class="panel panel-default">
              <div class="panel-heading" id="headingTwo">
                <h3 class="panel-title">
                  <span class="panel-trigger" val="#collapseTwo">
                    <span class="expand_icon dashicons-plus"></span>
                    <span
                      >How much do Partners earn in a month, when and where will
                      I receive the earnings generated from Upstox?</span
                    >
                  </span>
                </h3>
              </div>
              <div id="collapseTwo" class="panel-collapse collapse">
                <div class="panel-body">
                  Partners (sub-brokers) can earn in two ways<br />
                  ● Through AOI-Account Opening Incentive when you successfully
                  refer and onboard users <br />
                  ● Through Brokerage Commissions when your referred users’
                  trade on Upstox The more you refer and the more your referrals
                  trade, the more you earn. The referral reward gets credited to
                  your referral ledger by the 25th of every month.
                </div>
              </div>
            </div>

            <div id="more-faqs" class="d-none">
              <div class="panel panel-default">
                <div class="panel-heading" id="headingThree">
                  <h3 class="panel-title">
                    <span class="panel-trigger" val="#collapseFive">
                      <span class="expand_icon dashicons-plus"></span>
                      <span
                        >What are the tax implications? How do I claim TDS and
                        file GST?</span
                      >
                    </span>
                  </h3>
                </div>
                <div id="collapseFive" class="panel-collapse collapse">
                  <div class="panel-body">
                    TDS is levied when you cross the threshold limit of ₹15,000
                    in a Financial Year. For a TDS certificate, you can raise a
                    ticket or send an email on support@upstoxpartner.com. You
                    need to consult with a CA for filing GST returns.
                  </div>
                </div>
              </div>
              <div class="panel panel-default">
                <div class="panel-heading" id="headingThree">
                  <h3 class="panel-title">
                    <span class="panel-trigger" val="#collapseSix">
                      <span class="expand_icon dashicons-plus"></span>
                      <span
                        >How can I reach out to my referred leads to complete
                        the Account Opening Process?</span
                      >
                    </span>
                  </h3>
                </div>
                <div id="collapseSix" class="panel-collapse collapse">
                  <div class="panel-body">
                    You can simply login to your Partner Dashboard and check
                    your leads section.
                  </div>
                </div>
              </div>
              <div class="panel panel-default">
                <div class="panel-heading" id="headingThree">
                  <h3 class="panel-title">
                    <span class="panel-trigger" val="#collapseSeven">
                      <span class="expand_icon dashicons-plus"></span>
                      <span
                        >How can my leads get support for account opening and
                        trading related issues?
                      </span>
                    </span>
                  </h3>
                </div>
                <div id="collapseSeven" class="panel-collapse collapse">
                  <div class="panel-body">
                    Your leads and customers can reach out to us on our customer
                    helpline number 022-4179- 2999 / 022-6904-2299 (Mon – Sat:
                    10 AM to 7 PM) or raise a ticket from our web or app
                    platforms.
                  </div>
                </div>
              </div>
              <div class="panel panel-default">
                <div class="panel-heading" id="headingEight">
                  <h3 class="panel-title">
                    <span class="panel-trigger" val="#collapseEight">
                      <span class="expand_icon dashicons-plus"></span>
                      <span>Who can become a Partner with Upstox? </span>
                    </span>
                  </h3>
                </div>
                <div id="collapseEight" class="panel-collapse collapse">
                  <div class="panel-body">
                    Anyone above 18 years of age can become a Partner with
                    Upstox.
                  </div>
                </div>
              </div>
              <div class="panel panel-default">
                <div class="panel-heading" id="headingEight">
                  <h3 class="panel-title">
                    <span class="panel-trigger" val="#collapseTen">
                      <span class="expand_icon dashicons-plus"></span>
                      <span>What are the hidden charges in Upstox? </span>
                    </span>
                  </h3>
                </div>
                <div id="collapseTen" class="panel-collapse collapse">
                  <div class="panel-body">
                    There are no hidden charges on Upstox, we believe in
                    complete transparency with our prices. Click here for a
                    complete list of charges:
                    <a href="/brokerage-charges/"
                      >Brokerage Charges</a
                    >
                  </div>
                </div>
              </div>
              <div class="panel panel-default">
                <div class="panel-heading" id="headingEight">
                  <h3 class="panel-title">
                    <span class="panel-trigger" val="#collapseEleven">
                      <span class="expand_icon dashicons-plus"></span>
                      <span>Why choose Upstox? </span>
                    </span>
                  </h3>
                </div>
                <div id="collapseEleven" class="panel-collapse collapse">
                  <div class="panel-body">
                    Upstox is one of India’s fastest-growing wealth tech
                    platforms, empowering Indians to achieve their financial
                    goals. Co-founded by Mr. Ravi Kumar, Ms. Kavitha
                    Subramanian, and Mr. Kapil Jaikalyani and backed by Mr.
                    Ratan Tata, Upstox is loved and trusted by over 1.3 crore
                    Indians. Upstox is on a mission to enable every Indian to
                    invest right, trade right, and build wealth confidently.
                    With it’s advanced, fast and user-friendly mobile and
                    desktop platform, Upstox provides a comprehensive suite of
                    financial tools, enabling users to invest, trade, manage
                    wealth, protect wealth, learn about money, and save taxes
                    effortlessly. What sets Upstox apart is its dual-mode
                    feature, designed to cater to different user needs.<br /><br />

                    Upstox Pro: Designed for active traders, this mode provides
                    access to a range of trading options including Equities,
                    Futures, Options, Currencies, and Commodities. <br /><br />

                    Upstox for Investors: Tailored for newcomers and long-term
                    investing, this mode allows for investments in Stocks,
                    Mutual Funds, IPOs, Gold, and Fixed Income products like
                    T-Bills, G-Secs, SDLs, Fixed Deposits, NCDs. It also
                    includes Insurance products and personal loans.
                  </div>
                </div>
              </div>
            </div>
            <a class="btn-design view-more-button" target="_blank"
              >View More FAQ</a
            >
            <a class="btn-design view-less-button d-none" target="_blank"
              >View Less FAQs</a
            >
          </div>
        </div>
      </div>
    </section>
  </main>
</template>
<style scoped>
.wrapper{
  position: fixed !important;
  top: 24px !important;
}
#sync2 .owl-item.active{
  background: transparent !important;
}
</style>
